import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '@/locales/en';
import vi from '@/locales/vi';

// Define the resources type
export const resources = {
  en: { translation: en },
  vi: { translation: vi },
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'vi',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
